function getBoxAttributes(elm) {
    return {
        disabled: elm.disabled,
    };
}

export { getBoxAttributes as g };
